<template lang="html">
  <div class="dashboard">
    <div
      v-if="error"
      class="alert alert-danger text-center"
      role="alert">
      {{ error.message }}
    </div>
    <div class="row clearfix">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="widget filter-refresh">
          <div class="widget-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="state">
                <h2>
                  <select
                    class="form-control custom-select"
                    v-model="filterDate"
                    @change="onChangeFilter">
                    <option
                      v-for="option in filterDateOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </h2>
              </div>
              <div class="state">
                <h2>
                  <select
                    class="form-control custom-select"
                    v-model="filterType"
                    @change="onChangeFilter">
                    <option
                      v-for="option in filterTypeOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </h2>
              </div>
              <div class="icon">
                <i class="ik ik-clock" />
              </div>
            </div>
            <small class="text-small mt-10 d-block">Atualização dos dados em {{ refreshCount }} segundos</small>
          </div>
          <b-progress
            variant="success"
            :max="refreshTime"
            :value="refreshCount"
            height="8px" />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="widget calls-total">
          <div class="widget-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="state">
                <h6>Total Chamadas</h6>
                <h2>{{ callsTotal }}</h2>
              </div>
              <div class="icon">
                <i class="ik ik-phone-call" />
              </div>
            </div>
            <small class="text-small mt-10 d-block">HitRate: {{ hitRate }}%</small>
          </div>
          <b-progress
            variant="primary"
            :max="refreshTime"
            :value="refreshCount"
            height="8px" />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="widget answers-total">
          <div class="widget-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="state">
                <h6>Chamadas Atendidas</h6>
                <h2>{{ answersTotal }}</h2>
              </div>
              <div class="icon">
                <i class="ik ik-thumbs-up" />
              </div>
            </div>
            <small class="text-small mt-10 d-block">Tempo Falado: {{ durationsTotalTime }}</small>
          </div>
          <b-progress
            variant="danger"
            :max="refreshTime"
            :value="refreshCount"
            height="8px" />
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div class="widget extensions-total">
          <div class="widget-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="state">
                <h6>Total Ramais</h6>
                <h2>{{ extensionsTotal }}</h2>
              </div>
              <div class="icon">
                <i class="ik ik-users" />
              </div>
            </div>
            <small class="text-small mt-10 d-block">TMA: {{ tma }}</small>
          </div>
          <b-progress
            variant="info"
            :max="refreshTime"
            :value="refreshCount"
            height="8px" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card call-statistics">
          <div class="card-body">
            <canvas
              id="callStatistics"
              width="300"
              height="70" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card hangupcause-statistics">
          <div class="card-body">
            <canvas id="hangupcauseStatistics" />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card extension-statistics">
          <div class="card-body">
            <canvas
              id="extensionStatistics"
              width="300"
              height="40" />
          </div>
        </div>
      </div>
    </div>
    <div class="row float-right">
      <div class="col-md-12">
        <font
          title="Tutorial"
          size="6"
          color="black"
          @click.prevent="openTutorial">
          <i class="ik ik-youtube" />
        </font>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialDashboard"
      ref="tutorialDashboard"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Dashboard</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src="https://www.youtube.com/embed/rQGKsi1LVrk"
              title="Tutorial Dashboard"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import CDRDataSource from './../services/cdr-data-source'

const parse2Digits = (number) => ('0' + number).slice(-2)

const COLOR_PALETTE = [
  'rgb(66, 133, 244)',
  'rgb(219, 68, 55)',
  'rgb(80, 158, 89)',
  'rgb(244, 180, 53)',
  'rgb(173, 91, 188)',
  'rgb(36, 34, 132)',
  'rgb(137, 22, 29)',
  'rgb(240, 109, 64)',
  'rgb(158, 157, 36)',
  'rgb(236, 97, 146)',
  'rgb(53, 122, 108)',
  'rgb(38, 235, 242)',
  'rgb(255, 234, 10)',
  'rgb(255, 150, 150)',
  'rgb(132, 26, 125)',
  'rgb(34, 229, 109)',
  'rgb(157, 158, 113)',
  'rgb(232, 0, 58)',
  'rgb(179, 226, 70)'
]

export default {
  name: 'Dashboard',
  data () {
    return {
      error: null,
      callStatistics: null,
      hangupcauseStatistics: null,
      extensionStatistics: null,
      callsTotal: 0,
      answersTotal: 0,
      durationsTotal: 0,
      durationsTotalTime: '',
      hitRate: 0,
      tma: '',
      extensionsTotal: 0,
      timer: null,
      timeout: null,
      refreshTime: 30,
      refreshCount: 30,
      filterDate: JSON.stringify({
        name: 'today',
        startedAt: (_ => {
          let date = new Date()
          return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
        })(),
        endedAt: (_ => {
          let date = new Date()
          return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`
        })(),
        refreshTime: 30,
        refreshCount: 30
      }),
      filterDateOptions: [
        {
          text: 'Hoje',
          value: JSON.stringify({
            name: 'today',
            startedAt: (_ => {
              let date = new Date()
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
            })(),
            endedAt: (_ => {
              let date = new Date()
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`
            })(),
            refreshTime: 30,
            refreshCount: 30
          })
        },
        {
          text: 'Ontem',
          value: JSON.stringify({
            name: 'yesterday',
            startedAt: (_ => {
              let date = new Date()
              date = new Date(date.setDate(date.getDate() - 1))
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
            })(),
            endedAt: (_ => {
              let date = new Date()
              date = new Date(date.setDate(date.getDate() - 1))
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`
            })(),
            refreshTime: 30,
            refreshCount: 30
          })
        },
        {
          text: 'Últimos 7 dias',
          value: JSON.stringify({
            name: 'lastSevenDays',
            startedAt: (_ => {
              let date = new Date()
              date = new Date(date.setDate(date.getDate() - 7))
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
            })(),
            endedAt: (_ => {
              let date = new Date()
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`
            })(),
            refreshTime: 60,
            refreshCount: 60
          })
        },
        {
          text: 'Últimos 30 dias',
          value: JSON.stringify({
            name: 'lastThirtyDays',
            startedAt: (_ => {
              let date = new Date()
              date = new Date(date.setDate(date.getDate() - 30))
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
            })(),
            endedAt: (_ => {
              let date = new Date()
              return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`
            })(),
            refreshTime: 300,
            refreshCount: 300
          })
        }
      ],
      filterType: JSON.stringify({
        name: 'all',
        callType: null
      }),
      filterTypeOptions: [
        {
          text: 'Ambas',
          value: JSON.stringify({
            name: 'all',
            callType: null
          })
        },
        {
          text: 'Saínte',
          value: JSON.stringify({
            name: 'outbound',
            callType: 'outbound'
          })
        },
        {
          text: 'Entrante',
          value: JSON.stringify({
            name: 'inbound',
            callType: 'inbound'
          })
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      const filter = Object.assign(
        JSON.parse(this.filterType),
        JSON.parse(this.filterDate)
      )
      CDRDataSource.initialize(filter).then(_ => {
        this.error = null
        this.createDashboards()
      }).catch(err => {
        this.error = err
        console.error('CDRDataSource uninitialized', err)
      })

      this.countdown()
    })
  },
  methods: {
    countdown () {
      this.timer = _ => {
        if (this.refreshCount === 0) {
          this.refreshData().then(_ => {
            if (typeof this.timer === 'function') this.timer()
          })
        } else {
          this.timeout = setTimeout(_ => {
            this.refreshCount--
            if (typeof this.timer === 'function') this.timer()
          }, 1000)
        }
      }
      this.timer()
    },
    onChangeFilter (event) {
      if (event.target) {
        const filter = JSON.parse(this.filterDate)
        this.refreshTime = filter.refreshTime
        this.timer = null
        clearTimeout(this.timeout)
        this.countdown()
        this.refreshData()
      }
    },
    refreshData () {
      return new Promise((resolve, reject) => {
        this.refreshCount = this.refreshTime
        const filter = Object.assign(
          JSON.parse(this.filterType),
          JSON.parse(this.filterDate)
        )
        CDRDataSource.refreshDataFromAPI(filter).then(_ => {
          this.error = null
          this.updateDashboards()
          return resolve()
        }).catch(err => {
          this.error = err
          console.warn('CDRDataSource refreshDataFromAPI error:', err)
          return reject(err)
        })
      })
    },
    secondsToTimeParser (seconds) {
      let twoDigitsParser = (value) => {
        if (value < 10) {
          return `0${value}`.substr(-2)
        } else {
          return value
        }
      }
      seconds = parseInt(seconds)
      let hours = parseInt(seconds / 3600)
      seconds = seconds % 3600
      let minutes = parseInt(seconds / 60)
      seconds = seconds % 60
      return `${twoDigitsParser(hours)}:${twoDigitsParser(minutes)}:${twoDigitsParser(seconds)}`
    },
    createDashboards () {
      const callStatisticsContext = document.getElementById('callStatistics')
      CDRDataSource.callStatistics().then(({ labels, calls, answers, durations }) => {
        this.calculateStatistics(calls, answers, durations)
        this.callStatistics = new Chart(callStatisticsContext, {
          type: 'line',
          data: {
            labels: labels,
            datasets: [{
              label: 'Total Chamadas',
              data: Object.values(calls),
              pointBackgroundColor: 'rgb(66, 133, 244)',
              pointBorderWidth: 0,
              pointRadius: 2,
              borderColor: 'rgb(66, 133, 244)',
              borderWidth: 1,
              fill: false
            }, {
              label: 'Chamadas Atendidas',
              data: Object.values(answers),
              pointBackgroundColor: 'rgb(219, 68, 55)',
              pointBorderWidth: 0,
              pointRadius: 2,
              borderColor: 'rgb(219, 68, 55)',
              borderWidth: 1,
              fill: false
            }]
          },
          options: {
            responsive: true,
            legend: {
              position: 'top',
              labels: {
                usePointStyle: true
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  min: 0
                },
                stacked: false
              }]
            }
          }
        })
        const hangupcauseStatisticsContext = document.getElementById('hangupcauseStatistics')
        CDRDataSource.hangupcauseStatistics().then(({ labels, hangups }) => {
          this.hangupcauseStatistics = new Chart(hangupcauseStatisticsContext, {
            type: 'doughnut',
            data: {
              labels: labels,
              datasets: [{
                data: Object.values(hangups),
                backgroundColor: COLOR_PALETTE
              }],
              metadata: {
                callsTotal: this.callsTotal
              }
            },
            options: {
              responsive: true,
              legend: {
                position: 'bottom',
                labels: {
                  usePointStyle: true
                }
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    let label = data.labels[tooltipItem.index] || ''
                    if (label) {
                      if (data.datasets && data.datasets[tooltipItem.datasetIndex].data) {
                        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                        if (value) {
                          const valuePerc = Math.round(((value / data.metadata.callsTotal) * 100) * 100) / 100
                          label += ` - ${value} (${valuePerc} %)`
                        }
                      }
                    }
                    return label
                  }
                }
              }
            }
          })
          const extensionStatisticsContext = document.getElementById('extensionStatistics')
          CDRDataSource.extensionStatistics().then(({ labels, extensions, calls }) => {
            this.extensionsTotal = 0
            if (extensions) this.extensionsTotal = Object.keys(extensions).length
            let datasets = []
            let colorIndex = 0
            for (let call in calls) {
              datasets.push({
                label: call,
                data: Object.values(calls[call]),
                backgroundColor: COLOR_PALETTE[colorIndex],
                borderColor: COLOR_PALETTE[colorIndex],
                pointBorderWidth: 0,
                pointRadius: 2,
                borderWidth: 1,
                fill: false
              })
              colorIndex++
            }
            this.extensionStatistics = new Chart(extensionStatisticsContext, {
              type: 'line',
              data: {
                labels: labels,
                datasets: datasets
              },
              options: {
                responsive: true,
                legend: {
                  position: 'top',
                  labels: {
                    usePointStyle: true
                  }
                },
                scales: {
                  yAxes: [{
                    ticks: {
                      min: 0
                    },
                    stacked: false
                  }]
                }
              }
            })
          }).catch(err => {
            console.warn('CDRDataSource extensionStatistics error:', err)
          })
        }).catch(err => {
          console.warn('CDRDataSource hangupcauseStatistics error:', err)
        })
      }).catch(err => {
        console.warn('CDRDataSource.callStatistics:', err)
      })
    },
    updateDashboards () {
      CDRDataSource.callStatistics().then(({ labels, calls, answers, durations }) => {
        this.calculateStatistics(calls, answers, durations)
        this.callStatistics.data.labels = labels
        this.callStatistics.data.datasets = [{
          label: 'Total Chamadas',
          data: Object.values(calls),
          pointBackgroundColor: 'rgb(66, 133, 244)',
          pointBorderWidth: 0,
          pointRadius: 2,
          borderColor: 'rgb(66, 133, 244)',
          borderWidth: 1,
          fill: false
        }, {
          label: 'Chamadas Atendidas',
          data: Object.values(answers),
          pointBackgroundColor: 'rgb(219, 68, 55)',
          pointBorderWidth: 0,
          pointRadius: 2,
          borderColor: 'rgb(219, 68, 55)',
          borderWidth: 1,
          fill: false
        }]
        this.callStatistics.update()
        CDRDataSource.hangupcauseStatistics().then(({ labels, hangups }) => {
          this.hangupcauseStatistics.data.labels = labels
          this.hangupcauseStatistics.data.datasets = [{
            data: Object.values(hangups),
            backgroundColor: COLOR_PALETTE
          }]
          this.hangupcauseStatistics.data.metadata = {
            callsTotal: this.callsTotal
          }
          this.hangupcauseStatistics.update()
          CDRDataSource.extensionStatistics().then(({ labels, extensions, calls }) => {
            this.extensionsTotal = Object.keys(extensions).length || 0
            let datasets = []
            let colorIndex = 0
            for (let call in calls) {
              datasets.push({
                label: call,
                data: Object.values(calls[call]),
                backgroundColor: COLOR_PALETTE[colorIndex],
                borderColor: COLOR_PALETTE[colorIndex],
                pointBorderWidth: 0,
                pointRadius: 2,
                borderWidth: 1,
                fill: false
              })
              colorIndex++
            }
            this.extensionStatistics.data.labels = labels
            this.extensionStatistics.data.datasets = datasets
            this.extensionStatistics.update()
          }).catch(err => {
            console.warn('CDRDataSource extensionStatistics error:', err)
          })
        }).catch(err => {
          console.warn('CDRDataSource hangupcauseStatistics error:', err)
        })
      }).catch(err => {
        console.warn('CDRDataSource.callStatistics:', err)
      })
    },
    calculateStatistics (calls, answers, durations) {
      this.callsTotal = Object.entries(calls).reduce((total, obj) => {
        total += obj[1]
        return total
      }, 0)
      this.answersTotal = Object.entries(answers).reduce((total, obj) => {
        total += obj[1]
        return total
      }, 0)
      this.durationsTotal = Object.entries(durations).reduce((total, obj) => {
        total += obj[1]
        return total
      }, 0)
      this.durationsTotalTime = this.secondsToTimeParser(this.durationsTotal)
      this.tma = this.secondsToTimeParser(this.durationsTotal / (this.answersTotal === 0 ? 1 : this.answersTotal))
      this.hitRate = Math.round(((this.answersTotal / (this.callsTotal === 0 ? 1 : this.callsTotal)) * 100) * 100) / 100
    },
    openTutorial () {
      $(this.$refs.tutorialDashboard).modal('show')
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeout)
    this.timer = null
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue